import $ from 'jquery';
var inputListner;
var defaultCustomText = {};

$(() => {

  if ($('.memory-input').length) {

    var chaosStorage = window.localStorage;

    $('.memory-input').each(function(){
      var itemName = $(this).attr('name');

      defaultCustomText[itemName] = $('.memory-output[name='+itemName+']').text();

      if (chaosStorage.getItem(itemName)) {
        $('.memory-input[name='+itemName+']').val(chaosStorage.getItem(itemName))
      }

    });

    

    inputListner = setInterval(function() {
      $('.memory-input').each(function(){
        var itemName = $(this).attr('name');
        var inputText = $(this).val();
        var outputText;
        if (/\S/.test(inputText)) {
          outputText = inputText;
          chaosStorage.setItem(itemName, outputText);
        } else {
          outputText = defaultCustomText[itemName];
          chaosStorage.removeItem(itemName);
        }

        $('.memory-output[name='+itemName+']').text(outputText);
      })
      
    }, 300);
  
  }
});
